import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectPlaning = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "White",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		id: "Rectangle_694",
		"data-name": "Rectangle 694",
		width: 24,
		height: 24,
		fill: "rgba(255,255,255,0)"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_290",
		"data-name": "Path 290",
		d: "M1913.359,274.676h-5.888a.589.589,0,0,0-.589.589v4.121h-5.3a.589.589,0,0,0-.589.589V284.1h-5.3a.589.589,0,0,0-.589.589v8.244a.589.589,0,0,0,.589.589h17.664a.589.589,0,0,0,.589-.589V275.265A.589.589,0,0,0,1913.359,274.676Zm-12.365,17.665h-4.711v-7.066h4.711Zm5.888,0h-4.71V280.564h4.71Zm5.888,0h-4.71V275.854h4.71Z",
		transform: "translate(-1892.858 -272.292)"
	})]
});
export default SvgProjectPlaning;
